module.exports = globalThis.ajv7;